import { useState } from 'react';

export const useMenuOpen = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const OverflowHideScroll = 'overflow-hidden lg:overflow-scroll';
  const OverflowScroll = 'show-body';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.className = isMenuOpen ? OverflowScroll : OverflowHideScroll;
  };
  return {
    isMenuOpen,
    setIsMenuOpen,
    toggleMenu,
  };
};
